export function getDate (time, seperator) {
  let dt = new Date()
  if (!seperator) {
    seperator = ''
  }
  if (time) {
    if (dt.getMonth() + 1 - time <= 0) {
      let mouth = 13 + dt.getMonth() - time
      return `${dt.getFullYear() - 1}${seperator}${mouth < 10 ? '0' + Number(mouth) : mouth}${seperator}${dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()}`
    } else {
      return `${dt.getFullYear()}${seperator}${dt.getMonth() + 1 - time < 10 ? '0' + Number(dt.getMonth() + 1 - time) : dt.getMonth() + 1 - time}${seperator}${dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()}`
    }
  } else {
    return `${dt.getFullYear()}${seperator}${dt.getMonth() + 1 < 10 ? '0' + Number(dt.getMonth() + 1) : dt.getMonth() + 1}${seperator}${dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()}`
  }
}

export function getDay (classStartDate) {
  let currentDate = new Date()
  let startDate = new Date(classStartDate)
  let day = (startDate - currentDate) / 1000 / 3600 / 24
  classStartDate = classStartDate.replace('T', ' ')
  classStartDate = classStartDate.replace(/-/g, '/')
  return Math.ceil(day)
}



// WEBPACK FOOTER //
// ./src/api/js/getDate.js